module.exports = __webpack_public_path__ + "img/iphonese.7c1de487.jpg";